export interface MCPServer {
  id: string
  name: string
  description: string
  url: string
  requiresAuth: boolean
  capabilities: MCPCapability[]
  status: MCPServerStatus
}

export enum MCPServerStatus {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Connecting = 'connecting',
  Error = 'error'
}

export interface MCPCapability {
  name: string
  description: string
  parameters?: MCPParameter[]
}

export interface MCPParameter {
  name: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array'
  required: boolean
  description?: string
  default?: any
}

export interface MCPTool {
  name: string
  description: string
  inputSchema: {
    type: 'object'
    properties: Record<string, any>
    required?: string[]
  }
}

export interface MCPResource {
  uri: string
  name: string
  mimeType?: string
  description?: string
}

export interface MCPPrompt {
  name: string
  description?: string
  arguments?: Array<{
    name: string
    description?: string
    required?: boolean
  }>
}

export interface MCPConnection {
  serverId: string
  sessionId: string
  status: MCPServerStatus
  tools: MCPTool[]
  resources: MCPResource[]
  prompts: MCPPrompt[]
  error?: string
}
